import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7786ddb8 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _436c2a21 = () => interopDefault(import('../pages/after_user_verify.vue' /* webpackChunkName: "pages/after_user_verify" */))
const _ac4ca712 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _3817282e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _8735da2a = () => interopDefault(import('../pages/history.vue' /* webpackChunkName: "pages/history" */))
const _5b8e9665 = () => interopDefault(import('../pages/instruction.vue' /* webpackChunkName: "pages/instruction" */))
const _52f6d983 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _2d34a775 = () => interopDefault(import('../pages/main/index.vue' /* webpackChunkName: "pages/main/index" */))
const _1d4d140f = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _8d64dd7c = () => interopDefault(import('../pages/privacy_policy.vue' /* webpackChunkName: "pages/privacy_policy" */))
const _48ce00d4 = () => interopDefault(import('../pages/research.vue' /* webpackChunkName: "pages/research" */))
const _200ca408 = () => interopDefault(import('../pages/news/category/_id.vue' /* webpackChunkName: "pages/news/category/_id" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/v2/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _7786ddb8,
    name: "about___ja"
  }, {
    path: "/after_user_verify",
    component: _436c2a21,
    name: "after_user_verify___ja"
  }, {
    path: "/contact",
    component: _ac4ca712,
    name: "contact___ja"
  }, {
    path: "/en",
    component: _3817282e,
    name: "index___en"
  }, {
    path: "/history",
    component: _8735da2a,
    name: "history___ja"
  }, {
    path: "/instruction",
    component: _5b8e9665,
    name: "instruction___ja"
  }, {
    path: "/logout",
    component: _52f6d983,
    name: "logout___ja"
  }, {
    path: "/main",
    component: _2d34a775,
    name: "main___ja"
  }, {
    path: "/news",
    component: _1d4d140f,
    name: "news___ja"
  }, {
    path: "/privacy_policy",
    component: _8d64dd7c,
    name: "privacy_policy___ja"
  }, {
    path: "/research",
    component: _48ce00d4,
    name: "research___ja"
  }, {
    path: "/en/about",
    component: _7786ddb8,
    name: "about___en"
  }, {
    path: "/en/after_user_verify",
    component: _436c2a21,
    name: "after_user_verify___en"
  }, {
    path: "/en/contact",
    component: _ac4ca712,
    name: "contact___en"
  }, {
    path: "/en/history",
    component: _8735da2a,
    name: "history___en"
  }, {
    path: "/en/instruction",
    component: _5b8e9665,
    name: "instruction___en"
  }, {
    path: "/en/logout",
    component: _52f6d983,
    name: "logout___en"
  }, {
    path: "/en/main",
    component: _2d34a775,
    name: "main___en"
  }, {
    path: "/en/news",
    component: _1d4d140f,
    name: "news___en"
  }, {
    path: "/en/privacy_policy",
    component: _8d64dd7c,
    name: "privacy_policy___en"
  }, {
    path: "/en/research",
    component: _48ce00d4,
    name: "research___en"
  }, {
    path: "/en/news/category/:id?",
    component: _200ca408,
    name: "news-category-id___en"
  }, {
    path: "/news/category/:id?",
    component: _200ca408,
    name: "news-category-id___ja"
  }, {
    path: "/",
    component: _3817282e,
    name: "index___ja"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
